import type {FC} from 'react';
import {externalLinkToHref} from 'utils';

import type {FeaturedLinkSchema} from 'components/content-blocks/featured-links/schema';

import {FeaturedLinkDraft} from './draft';
import {FeaturedLinkRender} from './render';
import {FeaturedLinkServer} from './server';

interface Props {
	featuredLink: FeaturedLinkSchema;
	isDraft: boolean;
}

export const FeaturedLink: FC<Props> = ({featuredLink, isDraft}) => {
	if (featuredLink.link?.type === 'external') {
		return (
			<FeaturedLinkRender
				href={externalLinkToHref(featuredLink.link.href)}
				targetBlank={featuredLink.link.targetBlank}
				text={featuredLink.text}
				title={featuredLink.title}
				tagline={featuredLink.tagline}
				theme={featuredLink.theme}
			/>
		);
	}

	if (featuredLink.link?.type === 'internal') {
		return isDraft ? (
			<FeaturedLinkDraft featuredLink={featuredLink} />
		) : (
			<FeaturedLinkServer featuredLink={featuredLink} />
		);
	}

	return null;
};
